// extracted by mini-css-extract-plugin
export default {"container":"sVaYU","info":"YqiSv","block":"plC96"};